"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TooltipOnEllipsis = require('../tooltipOnEllipsis');

var validValues = {
  sizes: {
    options: ['tiny', 'small', 'medium', 'large'],
    defaultValue: 'medium'
  },
  weights: {
    options: ['thin', 'normal', 'bold'],
    defaultValue: 'normal'
  },
  skins: {
    options: ['standard', 'placeholder', 'premium', 'alert', 'success', 'link', 'secondary'],
    defaultValue: 'standard'
  }
};

var Text = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Text, _React$PureComponent);

  var _super = _createSuper(Text);

  function Text(props) {
    var _this;

    _classCallCheck(this, Text);

    _this = _super.call(this, props);

    _this.getValidStylingValues = function (values) {
      var size = values.size.toLowerCase();
      var weight = values.weight.toLowerCase();
      var skin = values.skin.toLowerCase();
      return {
        validSize: validValues.sizes.options.includes(size) ? size : validValues.sizes.defaultValue,
        validWeight: validValues.weights.options.includes(weight) ? weight : validValues.weights.defaultValue,
        validSkin: validValues.skins.options.includes(skin) ? skin : validValues.skins.defaultValue
      };
    };

    return _this;
  }

  _createClass(Text, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          light = _this$props.light,
          dataHook = _this$props.dataHook,
          enableEllipsis = _this$props.enableEllipsis,
          customEllipsisProps = _this$props.customEllipsisProps,
          disabled = _this$props.disabled,
          skin = _this$props.skin,
          size = _this$props.size,
          weight = _this$props.weight,
          translateIfNeeded = _this$props.translateIfNeeded;

      var _this$getValidStyling = this.getValidStylingValues({
        skin: skin,
        size: size,
        weight: weight
      }),
          validSize = _this$getValidStyling.validSize,
          validWeight = _this$getValidStyling.validWeight,
          validSkin = _this$getValidStyling.validSkin;

      var finalSkin = this.getFinalSkin(disabled, light, validSkin);
      return /*#__PURE__*/React.createElement("span", {
        "data-hook": dataHook,
        className: "control-text size-".concat(validSize, " weight-").concat(validWeight, " skin-").concat(finalSkin)
      }, enableEllipsis ? /*#__PURE__*/React.createElement(TooltipOnEllipsis, customEllipsisProps, translateIfNeeded(children)) : translateIfNeeded(children));
    } // If disabled or light props are passed then we override the skin

  }, {
    key: "getFinalSkin",
    value: function getFinalSkin(disabled, light, skin) {
      var selectedSkin = null;

      if (disabled) {
        selectedSkin = 'disabled';
      } else if (light && skin === 'standard') {
        selectedSkin = 'standard-light';
      } else if (light && skin === 'secondary') {
        selectedSkin = 'secondary-light';
      }

      selectedSkin = selectedSkin || skin;
      return selectedSkin;
    }
  }]);

  return Text;
}(React.PureComponent);

Text.displayName = displayNames.TEXT;
Text.propTypes = {
  /** The actual text to be rendered*/
  children: PropTypes.string,

  /** Hook for testing purposes  */
  dataHook: PropTypes.string,

  /** Font-size of the text */
  size: PropTypes.oneOf(validValues.sizes.options),

  /** Font weight of the text */
  weight: PropTypes.oneOf(validValues.weights.options),

  /** Skin color of the text */
  skin: PropTypes.oneOf(validValues.skins.options),

  /** Set text with lighter color - effect Standard and Secondary skins only */
  light: PropTypes.bool,

  /** Set text with disabled styling */
  disabled: PropTypes.bool,

  /** When set to false the text goes multiline without ellipsis nor tooltip  */
  enableEllipsis: PropTypes.bool,

  /** Custom props to override the default behaviour of the wrapping ToolTipOnEllipsis component */
  customEllipsisProps: PropTypes.object
};
Text.defaultProps = {
  dataHook: 'Text',
  size: validValues.sizes.defaultValue,
  weight: validValues.weights.defaultValue,
  skin: validValues.skins.defaultValue,
  light: false,
  disabled: false,
  enableEllipsis: true
};
module.exports = compose(Text);